(function () {
    'use strict';

    /**
     * @ngdoc object
     * 
     *
     * @description
     *
     */
    angular
        .module('paxMessage')
        .controller('OverrideCtrl', OverrideCtrl);

    function OverrideCtrl($uibModalInstance, modalParams, PaxMessageService, MessageService,EventManagerService) {
        var vm = this;

        vm.model = {
            params: {
            	paxMsgJourneyCrewId : modalParams.paxMsgJourneyCrewId,
            	paxMsgSchdId : modalParams.paxMsgSchdId,
            	overideCode : modalParams.overideCode
            }
        	
        };

        vm.override = function () {
        	PaxMessageService.override(vm.model.params,
                  function (response) {
                     if (response.success) {
                        MessageService.success(MessageService.MESSAGES.CREWING.SUCCESS_SAVE_MESSAGE);
                        $uibModalInstance.close();
                		EventManagerService.notifyEventListeners(EventManagerService.EVENT.DO_REFRESH);
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
            };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };
    }
}());
